package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.Workplace
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class GetWorkplaceUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    /**
     * Zwraca strumień grafików dla danego miejsca pracy.
     * Służy do wyświetlania listy: "Styczeń (Opublikowany)", "Luty (Szkic)".
     */
    suspend operator fun invoke(workplaceId: String): Result<Workplace> {
        return workplaceRepository.getWorkplace(workplaceId)
    }
}